import React, {useState, useEffect} from 'react'
import AttachTagItemTable from './AttachTagItemTable'
import {getListAttachTagItem, exportListAttachTagItem, getListBrand} from '../../../services/api/3dApi'
import {Link} from 'react-router-dom'
import {Pagination, Select, Button, Spin, message} from 'antd'
import SelectFilterOptions from '../../shared/SelectFilterOptions'
import FilterDateRangeV2 from '../../shared/FilterDateRangeV2'
import FilterProductType from '../../batchesV3/components/filters/FilterProductType'
import * as storageService from '../../../services/StorageServices'
import {getUserList} from '../../../services/api/UserService'
import {createJobExport} from '../../../helpers/createJobExport'
import downloadFileFromData from '../../../helpers/downloadFileFromData'
import moment from 'moment'

function AttachTagItemPage() {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [total, setTotal] = useState(0)
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(50)
    const [listAttachTagItem, setListAttachTagItem] = useState([])
    const [listBrand, setListBrand] = useState([])
    const [brand, setBrand] = useState([])
    const [listUser, setListUser] = useState(storageService.getLocalData('attachTagItemUsers', []) || [])
    const [user, setUser] = useState([])
    const [type, setType] = useState([])
    const [taggedAt, setTaggedAt] = useState({})

    const fetchUsersAttachTag = async () => {
        try {
            const payload = {
                page: 1, 
                limit: 10000, 
                is_active: true
            }

            const {data, message, success} = await getUserList(payload)

            if (!success) {
                console.log(message)
            } else {
                storageService.setLocalData('attachTagItemUsers', data.data)
                setListUser(data.users)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const fetchAttachTagItem = async () => {
        setLoading(true)

        try {
            const payloadAttachTag = {
                limit: limit,
                page: page,
            }

            if (!!user) payloadAttachTag.user = user
            if (brand.length) payloadAttachTag.brand = brand
            if (type.length) payloadAttachTag.sku = type
            if (Object.keys(taggedAt).length) {
                payloadAttachTag['tagged_at[from]'] = moment(taggedAt.from, 'DD/MM/YYYY').format('DD-MM-YYYY')
                payloadAttachTag['tagged_at[to]'] = moment(taggedAt.to, 'DD/MM/YYYY').format('DD-MM-YYYY')
            }

            const {data: res} = await getListAttachTagItem(payloadAttachTag)

            const {data, success, message: mess} = {...res}

            if (success) {
                setListAttachTagItem(data.barcodes)
                setTotal(data.total)
                setLimit(data.limit)
                setPage(data.page)
            } else {
                setError(mess)
                message.error(mess)
            }
        } catch (error) {
            setError(error.message)
            message.error(error.message)
        } finally {
            setLoading(false)
        }
    }

    const _getListBrandAttachTag = async () => {
        try {
            const payloadBrand = {
                limit: 10000,
                page: 1
            }

            const {data: Data} = await getListBrand(payloadBrand)
            const {data, success, message} = Data

            const Brands = data.Brands.map(i => ({value: i.name, label: i.name}))

            if (success) {
                setListBrand(Brands)
            } else {
                console.log(message)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleChangeUser = (field, value) => {
        setUser(value)
        setPage(1)
    }

    const handleChangeBrand = (value) => {
        setBrand(value)
        setPage(1)
    }

    const handleChangeTaggedAt = (field, value) => {
        setTaggedAt(value)
        setPage(1)
    }

    const handleChangeType = (value) => {
        setType(value)
        setPage(1)
    }

    const exportAttachTagItem = async () => {
        setLoading(true)
        setError('')

        try {
            const payloadExport = {
                page: page,
                limit: limit,
            }

            if (brand.length) payloadExport.brand = brand
            if (!!user && user.length) payloadExport.user = user
            if (type.length) payloadExport.sku = type
            if (Object.keys(taggedAt).length) {
                payloadExport['tagged_at[from]'] = moment(taggedAt.from, 'DD/MM/YYYY').format('DD-MM-YYYY')
                payloadExport['tagged_at[to]'] = moment(taggedAt.to, 'DD/MM/YYYY').format('DD-MM-YYYY')
            }

            const {data: response} = await exportListAttachTagItem(payloadExport)

            if (typeof response !== 'string') {
                const {success, message: mess, data} = response

                if (!success) throw new Error(mess)

                if (Object.keys(data).length > 0) {
                    createJobExport(data)
                }
            } else {
                if (response) downloadFileFromData(response, {filename: `attach-tag-items-${moment().format('YYYY-MM-DD-HH-mm-ss')}.csv`})
            }
        } catch (e) {
            setError(e.message)
            setLoading(false)
        } finally {
            setLoading(false)
        }
    }

    const handleShowSizeChangeAttachTag = (current, size) => {
        setPage(1)
        setLimit(size)
    }

    const handlePageChangeAttachTag = (current) => {
        setPage(current)
    }

    useEffect(() => {
        fetchAttachTagItem()
    }, [user, brand, taggedAt, type, limit, page])

    useEffect(() => {
        fetchUsersAttachTag()
        _getListBrandAttachTag()
    }, [])

    const {Option} = Select
    const disableOptionBrand = !!brand && brand.length > 0 && brand.includes('no brand')
    const disableNoBrand = !!brand && brand.length > 0 && !brand.includes('no brand')

    const listuser = !!listUser && !!listUser.length && listUser.map(i => ({
        name: i.username,
        value: i.username,
    }))

    return (
        <div className='AttachTagItemPage'>
            <div className='container-fluid min-vh-100'>
                <div className='col-12 mx-auto bg-white shadow-sm py-3'>
                    <div className='mb-3 d-flex justify-content-between mt-3'>
                        <h3 className='mb-0'>Danh sách item gắn tag mác</h3>
                        <div className='d-flex align-items-center'>
                            <Button
                                className='ant-btn ant-btn-primary ml-3'
                                onClick={exportAttachTagItem}
                                disabled={loading}
                            >
                                Export
                            </Button>
                            <Link
                                className='ant-btn ml-3'
                                to='/attach-tag'
                                disabled={loading}
                            >
                                Đánh dấu gắn tag mác
                            </Link>
                        </div>
                    </div>
                    <div className='jumbotron p-3 mb-3'>
                        <div className='row align-items-start'>
                            <div className='col-12 col-xl-4'>
                                <label className='font-weight-bold mb-1'>Loại sản phẩm:</label>
                                <FilterProductType
                                    productTypes={type}
                                    onChangeProductType={handleChangeType}
                                />
                            </div>

                            <div className='col-12 col-xl-2'>
                                <label htmlFor="request_update" className="d-block w-100 font-weight-bold mb-1">Brand</label>
                                <Select
                                    mode={'multiple'}
                                    allowClear
                                    name='brand'
                                    value={brand}
                                    placeholder='Chọn brand name'
                                    className='brand'
                                    onChange={(value) => handleChangeBrand(value)}
                                    showArrow
                                    style={{width: '100%'}}
                                >
                                    <Option disabled={disableNoBrand} value='no brand'> No brand</Option>
                                    {
                                        listBrand.length && 
                                        listBrand.map((i, index) => (
                                            <Option disabled={disableOptionBrand} value={i.value}
                                                    key={index}>{i.label}</Option>
                                        ))
                                    }
                                </Select>
                            </div>
                            <div className='col-12 col-xl-auto'>
                                <div className='font-weight-bold mb-1'>Người gắn tag mác: </div>
                                <SelectFilterOptions
                                    listOptions={listuser || []}
                                    defaultValue={user}
                                    field='user'
                                    mode="multiple"
                                    handleChange={handleChangeUser}
                                    allowClear={true}
                                    placeholder="Chọn người gắn tag mác"
                                    style={{width: 300}}
                                />
                            </div>
                            <div className='col-12 col-xl-auto'>
                                <label className="font-weight-bold mb-1">Thời gian gắn tag mác</label>
                                <FilterDateRangeV2
                                    field='tagged_at'
                                    onDatesChange={handleChangeTaggedAt}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-3 headPagination AttachTagItemPagination">
                        <div>
                            {error && <div className='text-danger'>{error}</div>}
                        </div>
                        <Pagination
                            total={total}
                            current={page}
                            pageSize={limit}
                            className='text-right' 
                            pageSizeOptions={['10', '20', '50', '100']}
                            showSizeChanger
                            showTotal={(sum, range) => sum > 0 &&
                                <div>
                                    {`Hiển thị ${range[0]} đến ${range[1]} của `}<strong>{`${total} lô hàng`}</strong>
                                </div>}
                            onShowSizeChange={handleShowSizeChangeAttachTag}
                            onChange={handlePageChangeAttachTag}
                            disabled={loading}
                        />
                    </div>
                    <Spin spinning={loading} tip='Loading...'>
                        <AttachTagItemTable
                            listAttachTagItem={listAttachTagItem}
                            setType={setType}
                            setBrand={setBrand}
                            setUser={setUser}
                        />
                    </Spin>
                    <Pagination
                        current={page}
                        total={total}
                        pageSize={limit}
                        className='text-right'
                        showSizeChanger
                        showQuickJumper
                        pageSizeOptions={['10', '20', '50', '100']}
                        onChange={handlePageChangeAttachTag}
                        onShowSizeChange={handleShowSizeChangeAttachTag}
                        disabled={loading}
                    />
                </div>
            </div>
        </div>
    )
}

export default AttachTagItemPage
